<template>
	<el-container>
		<el-main>
			<div style="margin-bottom: 30px;">
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item class="item_font">开口机器人</el-breadcrumb-item>
					<el-breadcrumb-item><span class="item_font">测试</span></el-breadcrumb-item>
				</el-breadcrumb>
			</div>
			<!-- <div style="text-align: left;">
				<el-radio-group v-model="radio">
					<el-radio :label="1">当前模型</el-radio>
					<el-radio :label="2">编辑模型</el-radio>
				</el-radio-group>
			</div> -->
			<div class="top">
				<div style="width: 400px;">
					<el-input size="medium" placeholder="输入关键字搜索" suffix-icon="el-icon-search" v-model="text" @keyup.enter.native="enterSelect"></el-input>
				</div>
				<div style="margin-top: 5px;">
					<el-button type="primary" @click="clickSearch" size="mini" class="item_font">询问</el-button>
				</div>
			</div>
			<div class="contextShow">
				<div class="item_font">
					<span class="title">匹配语料：</span>
					<span class="text">{{form.query}}</span>
				</div>
				<div class="item_font">
					<span class="title">匹配话题：</span>
					<span class="text">{{form.topicName}}</span>
				</div>
				<div class="item_font">
					<span class="title">匹配话术：</span>
					<div class="context">
						<div v-for="(item,index) in form.contentList" :key="index">{{index+1}}. {{item}}</div>
					</div>
				</div>
				<div style="display: flex;flex-direction: column;">
					<div class="title" style="line-height: 16px;">匹配数据：</div>
					<div style="display: flex;flex-direction: column;" v-if="data===true" class="item_font">
						<div class="text1">主题块：{{form.topicPart}}</div>
						<!-- <div class="text1">主题块2：{{form.topic1Part}}</div> -->
						<div class="text1">现象块1：{{form.feature1Part}}</div>
						<div class="text1">现象块2：{{form.feature2Part}}</div>
						<div class="text1">疑问词块：{{form.quePart}}</div>
						<div class="text1">疑问焦点词块：{{form.queFocusPart}}</div>
					</div>
				</div>
			</div>
		</el-main>
	</el-container>
</template>

<script>
	export default {
		name:'testRobot',
		data() {
			return {
				// radio:1,
				text:"",
				data:false,
				myHeaders:{Authorization:localStorage.getItem("token")},
				form:{query:"",topicName:"",contentList:[],topicPart:"",topic1Part:"",feature1Part:"",feature2Part:"",quePart:"",queFocusPart:""},
			}
		},
		mounted() {
			// let self = this
			// 	document.onkeydown = function(e) {
			// 		let ev = document.all ? window.event : e
			// 		if (ev.keyCode === 13) {
			// 			self.querySelect()
			// 		}
			// 	}
		},
		methods: {
			// 查询语句
			async querySelect() {
				// 查询语句
				var api = "/manager/talkCorpus/robotTest";
				const response =await this.util.postRequest({
					url: api,
					method: "POST",
					data: {
						query:this.text
					},
					itype:"1"
				});
				console.log("*****querySelect *****", response);
				this.data=true
				if(response.data.length===0){
					console.log("无数据")
					this.form={query:"",topicName:"",contentList:[]}
				}else{
					this.form =response.data[0]
				}
			},
			clickSearch() {
				this.querySelect()
				// if(this.radio===1){
				// 	this.querySelect()
				// 	console.log("当前模型")
					
				// }else if(this.radio===2){
				// 	console.log("编辑模型")
				// }
			},
			enterSelect(e){
				var keyCode = window.event? e.keyCode:e.which;
				if(keyCode == 13){
					this.querySelect()
				}
				
			},
		}
	}
</script>

<style>
	.top{
		display: flex;
		flex-direction: row;
		justify-content: space-between; 
		margin-top: 15px;
		width: 80%;
	}
	.contextShow{
		display: flex;
		flex-direction: column;
		margin-top: 15px;
		width: 80%;
		line-height: 45px;
		font-size: 15px;
		text-align: left;
	}
	.title{
		font-weight: bold;
		@include change_size($font_size_normal)
	}
	.text{
		color:#55aaff
	}
	.context{
		display: flex;
		flex-direction: column;
		color: #737373;
		margin-left: 15px;
		line-height: 35px;
		font-size: 15px;
	}
	.text1{
		margin-left: 15px;
		line-height: 35px;
	}
	
</style>
